import { jwtDecode } from 'jwt-decode'

/**
 * Retrieves the user ID from the JWT stored in local storage.
 * @returns {{ id: string; roles: string[] }} The object with ID and Roles, otherwise null.
 */

export const getUserIdAndRolesFromToken = (): { id: string; roles: string[] } | null => {
  const token = localStorage.getItem('ACCESS_TOKEN')

  if (!token) {
    return null
  }

  try {
    const decodedToken: { id: string; roles: string[] } = jwtDecode(token)
    if (!decodedToken?.id || (decodedToken?.roles && decodedToken.roles?.length < 1)) {
      return null
    }
    return { id: decodedToken.id, roles: decodedToken.roles }
  } catch (error) {
    return null
  }
}
